<template>
	<div>
		<AppHeader title="아이디 찾기" is-history></AppHeader>
		<AppContent>
			<FindIdDetail></FindIdDetail>
		</AppContent>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import FindIdDetail from '@/components/findId/index';

export default {
	components: {
		AppHeader,
		AppContent,
		FindIdDetail,
	},
};
</script>
